/**
 * Detects if the application is running inside an iframe
 * @returns true if running in iframe, false otherwise
 */
export const isIframe = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    return window.self !== window.top;
  } catch (e) {
    // If we can't access window.top due to cross-origin restrictions,
    // we're likely in an iframe
    return true;
  }
};

/**
 * Determines if the menu should be hidden (regular sidebar)
 * Returns true if in iframe mode (should hide regular sidebar)
 * @returns true if menu should be hidden, false otherwise
 */
export const shouldHideMenu = (): boolean => {
  return isIframe();
};

